import { render } from "./SubjectSelection.vue?vue&type=template&id=309b5751"
import script from "./SubjectSelection.vue?vue&type=script&lang=js"
export * from "./SubjectSelection.vue?vue&type=script&lang=js"

import "./SubjectSelection.vue?vue&type=style&index=0&id=309b5751&lang=css"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__